export const groupBillingItems = (data) => {
	// 1. Lọc bỏ usage + bỏ description "Remaining time"
	const filtered = data.filter(
		item =>
			!item.lockup?.startsWith("usage")
	);

	const groups = {};
	const taxGroups = {};
	const noLockup = [];

	for (const item of filtered) {
		if (!item.lockup) {
			noLockup.push(item);
			continue;
		}

		const match = item.lockup.match(/(add_on|plan)\.([^.]+?)(?:_|$)/);
		if (match) {
			const type = match[1];
			const idRoot = `${type}.${match[2]}`;
			if (!groups[idRoot]) groups[idRoot] = [];
			groups[idRoot].push(item);
			continue;
		}

		// Nhóm tax
		const taxMatch = item.lockup.match(/tax\.([^.]*)(?:_|$)?/);
		if (taxMatch) {
			const idRoot = `tax.${taxMatch[1] || ''}`;
			if (!taxGroups[idRoot]) taxGroups[idRoot] = [];
			taxGroups[idRoot].push(item);
			continue;
		}
	}

	const result = [];

	// Xử lý nhóm không có lockup (general)
	if (noLockup.length) {
		result.push({
			type: "general",
			id: "general",
			name: noLockup[0].name,
			amount: noLockup[0].amount,
			description: noLockup[0].description,
			items: noLockup.slice(1) // phần còn lại
		});
	}

	// Xử lý add_on và plan
	for (const [id, items] of Object.entries(groups)) {
		const type = id.startsWith("plan") ? "plan" : "add_on";
		const mainItem = items.find(item => item.description?.includes("1 ×")) || items[0];
		const subItems = items.filter(it => it !== mainItem);

		result.push({
			type,
			id,
			name: mainItem.name,
			amount: mainItem.amount,
			description: mainItem.description,
			items: subItems
		});
	}

	// Xử lý tax group
	for (const [id, items] of Object.entries(taxGroups)) {
		// tax group may not have name field, use description if not
		const mainItem = items[0];
		result.push({
			type: "tax",
			id,
			name: mainItem.name || "Tax",
			amount: mainItem.amount,
			description: mainItem.description,
			items: items.slice(1)
		});
	}

	// Sort: plan → add_on → general
	const order = { plan: 1, add_on: 2, general: 3 };
	return result.sort((a, b) => {
		if (order[a.type] !== order[b.type]) return order[a.type] - order[b.type];
		return a.name.localeCompare(b.name);
	});
}

export const groupBillingItemsChangeFleetBillingPlan = (data) => {
	// Lọc bỏ usage
	if (!data || data.length === 0) return [];
	const filtered = data.filter(
		item => !item.lockup?.startsWith("usage")
	);

	const groups = {};
	const taxGroups = {};
	const noLockup = [];

	for (const item of filtered) {
		if (!item.lockup) {
			noLockup.push(item);
			continue;
		}

		// Nhóm plan và add_on
		const match = item.lockup.match(/(add_on|plan)\.([^.]+?)(?:_|$)/);
		if (match) {
			const type = match[1];
			const idRoot = `${type}.${match[2]}`;
			if (!groups[idRoot]) groups[idRoot] = [];
			groups[idRoot].push(item);
			continue;
		}

		// Nhóm tax
		const taxMatch = item.lockup.match(/tax\.([^.]*)(?:_|$)?/);
		if (taxMatch) {
			const idRoot = `tax.${taxMatch[1] || ''}`;
			if (!taxGroups[idRoot]) taxGroups[idRoot] = [];
			taxGroups[idRoot].push(item);
			continue;
		}
	}

	const result = [];

	// Xử lý từng group (plan/add_on)
	for (const [id, items] of Object.entries(groups)) {
		const type = id.startsWith("plan") ? "plan" : "add_on";

		// Phân loại items theo description
		const unusedTimeItems = items.filter(item => item.description?.includes("Unused time"))?.map(item => ({
			...item,
			name: "Prorated Deduction"
		}));
		const setupFeeItems = items.filter(item => item.name?.includes("Setup fee"));
		const otherItems = items.filter(item =>
			!item.description?.includes("Unused time") && !item.name?.includes("Setup fee")
		);

		// Main item là item đầu tiên trong otherItems (amount tổng của type)
		const mainItem = otherItems[0];

		// Tạo subItems: setupFeeItems + otherItems (trừ mainItem)
		const subItems = [
			...setupFeeItems,
			...otherItems.slice(1)
		];

		// Tách unused time items thành items riêng của type này
		const allItems = [...subItems];
		if (unusedTimeItems.length > 0) {
			allItems.push(...unusedTimeItems.map(item => ({
				...item,
				isUnusedTime: true
			})));
		}

		if (mainItem) {
			result.push({
				type,
				id,
				name: mainItem.name,
				amount: mainItem.amount,
				description: mainItem.description,
				items: allItems
			});
		}
	}

	// Xử lý tax group
	for (const [id, items] of Object.entries(taxGroups)) {
		// Tax: cho phép nhiều taxes, mỗi tax có 1 mainItem và subItems
		const mainItem = items[0];
		const subItems = items.slice(1);
		result.push({
			type: "tax",
			id,
			name: mainItem.name,
			amount: mainItem.amount,
			description: mainItem.description,
			items: subItems
		});
	}

	// Xử lý noLockup items - gộp vào plan đầu tiên hoặc tạo plan mới (vẫn không thay đổi logic này)
	const planGroups = result.filter(item => item.type === "plan");

	if (planGroups.length > 0) {
		// Gộp noLockup vào plan đầu tiên
		const firstPlan = planGroups[0];
		const allPlanItems = [...firstPlan.items, ...noLockup];
		console.log('firstPlan', firstPlan)
		firstPlan.items = allPlanItems.filter(i => i.amount !== 0);
	} else if (noLockup.length > 0) {
		// Tạo plan mới từ noLockup
		const mainItem = noLockup.find(item => !item.name?.includes("1 ×")) || noLockup[0];
		const subItems = noLockup.filter(item => item !== mainItem);

		result.push({
			type: "plan",
			id: "plan.default",
			name: mainItem.name,
			amount: mainItem.amount,
			description: mainItem.description,
			items: subItems.filter(i => i.amount !== 0)
		});
	}

	return {
		plan: result.filter(item => item.type === "plan"),
		addOns: result.filter(item => item.type === "add_on"),
		tax: result.filter(item => item.type === "tax"),
	};
}

export const handleResultBillingPayment = (res) => {
	const isSuccess = res?.returnCode === 200
	const is3ds = res?.returnCode === 113 && res?.response?.url
	if (is3ds) {
		window.location.href = res?.response?.url
	}
	return {
		isSuccess,
		is3ds
	}
}	